import { BranchOfficeRole } from 'types/roles/BranchOfficeRole';
import { useHasBranchOfficeRole } from './use-has-branch-office-role';

export const useIsOgpPlannerOrHigher = () => useHasBranchOfficeRole(BranchOfficeRole.PLANNER);
